<template>
    <v-main
            v-if="landing_data"
            style="height: 100vh;"
            :style="{ 'background': landing_data.background_type === '1' ? landing_data.background_color : landing_data.background_image }"
    >
        <img
                :src="$vuetify.breakpoint.smAndDown ? landing_data.cover_image_mobile : landing_data.cover_image_desktop"
                width="100%"
        >
<!--        <div style="position: absolute; top: 50%; right: 50%;">-->
<!--            {{landing_data.title}}-->
<!--        </div>-->
        <div class="d-flex justify-center layout-position">
            <div class="px-10 layout-button">
                <div class="d-flex justify-center align-center" style="height: 100%">
                    <span class="link-btn" @click="enterSite('th')">เข้าชมเว็บไซต์</span>
                    <span class="mx-3">|</span>
                    <span class="link-btn" @click="enterSite('en')">Enter Site</span>
                </div>
            </div>
        </div>
    </v-main>
</template>

<script>
    import { mapMutations, mapState } from 'vuex';
    export default {
        name: "LandingPage",
        computed: {
          ...mapState({
              landing_data: state => {
                  if (state.Landing.landing_data) {
                      return state.Landing.landing_data
                  }
              }
          })
        },
        async created() {
          await this.$store.dispatch('Landing/getBannerBg');
          if (!this.landing_data) {
              this.$router.push("/home");
          }
        },
        methods: {
            ...mapMutations('Branch',['setLang']),
            async enterSite(lang) {
                this.$i18n.locale = lang;
                await this.setLang(lang);
                this.$router.push("/home");
            }
        }
    }
</script>

<style scoped>
    .layout-position {
        position: fixed;
        bottom: 80px;
        left: 0;
        right: 0;
    }
    .layout-button {
        height: 50px;
        border-radius: 30px;
        border: 1px solid #ccc;
        background: white;
    }
    .link-btn {
        color: #222;
        cursor: pointer;
        user-select: none;
    }
    .link-btn:hover {
        color: #34A93E;
    }
</style>
